import { render } from "./BlankBox.vue?vue&type=template&id=7ca71ce4&scoped=true"
import script from "./BlankBox.vue?vue&type=script&lang=js"
export * from "./BlankBox.vue?vue&type=script&lang=js"

import "./BlankBox.vue?vue&type=style&index=0&id=7ca71ce4&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca71ce4"]])

export default __exports__